<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
        return{
           
        }
    },    
    methods: {
    },
    // <!--在watch中监听实时宽高-->
    watch: {
      
    },
 
    
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue